// extracted by mini-css-extract-plugin
export default {"container":"MainContainer_container__8sMjk","show":"MainContainer_show__UBB5c","hide":"MainContainer_hide__RXRd5"};